// Ay-Yıldız Sembolü (Türk Bayrağı)
const TurkishCrescent = ({ className = "w-8 h-8" }) => (
  <svg className={className} viewBox="0 0 100 100" fill="currentColor">
    {/* Ay */}
    <circle cx="35" cy="50" r="25" fill="white" />
    <circle cx="40" cy="50" r="20" fill="currentColor" />
    {/* Yıldız */}
    <path d="M 70 35 L 73 43 L 82 43 L 75 49 L 78 57 L 70 51 L 62 57 L 65 49 L 58 43 L 67 43 Z" fill="white" />
  </svg>
);

export default TurkishCrescent;